import { Component } from '@angular/core';
import { NotificationsService } from 'src/app/shared/services/notifications.service';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { MatDialog } from '@angular/material/dialog';
import { InformativeDialogComponent } from 'src/app/shared/components/informative-dialog/informative-dialog.component';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { SupabaseUserToolsService } from 'src/app/shared/services/supabase-user-tools.service';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-announcements',
  imports: [TranslatePipe, MatIcon],
  templateUrl: './announcements.component.html',
  styleUrl: './announcements.component.scss',
})
export class AnnouncementsComponent {
  constructor(
    private notificationsService: NotificationsService,
    private translationService: TranslationService,
    public dialog: MatDialog,
    public supabaseUserToolsService: SupabaseUserToolsService
  ) {}

  public announcement_title = '';
  public announcement_body = '';
  public announcement_id = -1;
  public isAdmin = false;

  async ngOnInit() {
    const announcement =
      await this.notificationsService.getLatestAnnouncement();
    if (announcement && announcement.length > 0) {
      this.announcement_title = announcement[0].title;
      this.announcement_body = announcement[0].body;
      this.announcement_id = announcement[0].id;
    }

    this.isAdmin = await this.supabaseUserToolsService.isUserAdmin();
  }

  removeAnnouncement(a_id: number): void {
    const dialogRef = this.dialog.open(InformativeDialogComponent, {
      data: {
        title: this.translationService.translate('Confirm deletion'),
        description: this.translationService.translate(
          'Are you sure you want to delete this announcement?'
        ),
        confirmText: this.translationService.translate('Delete'),
        rejectText: this.translationService.translate('Cancel'),
      },
    });

    dialogRef.afterClosed().subscribe(async (result: boolean) => {
      if (result) {
        await this.notificationsService.deleteAnouncementByAdmin(a_id);
        this.announcement_id = -1;
      } else {
        console.log('discarded deletion');
      }
    });
  }
}
